import {BrowserUtils} from '@commonUtils/browser';

export function ajaxPost (url, payload, successCb, errorCb) {
  const cookies = BrowserUtils.parseCookie(document.cookie);
  let ignoreCsrfToken = false
  if (url.startsWith('http') || url.startsWith('https')) {
    if (new URL(url).origin !== location.origin) {
      ignoreCsrfToken = true
    }
  }

  if (window.fetch) {
    const headers = {
      'Content-Type': 'application/json'
    }
    if (cookies['XSRF-TOKEN'] && !ignoreCsrfToken) {
      headers['X-XSRF-TOKEN'] = cookies['XSRF-TOKEN']
    }
    window.fetch(url, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers
    }).then(function (response) {
      if (response.status === 200) {
        return response.json()
      } else {
        return response.json().then(errorCb)
      }
    }).then(function (data) {
      successCb(data)
    }).catch(function (err) {
      errorCb(err)
    })
  } else {
    const xhr = new XMLHttpRequest()
    // xhr.timeout = 30000
    xhr.open('POST', url)
    xhr.setRequestHeader('Content-Type', 'application/json')
    if (cookies['XSRF-TOKEN'] && !ignoreCsrfToken) {
      xhr.setRequestHeader('X-XSRF-TOKEN', cookies['XSRF-TOKEN'])
    }
    xhr.send(JSON.stringify(payload))
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          successCb(JSON.parse(xhr.responseText))
        } else {
          errorCb(JSON.parse(xhr.responseText))
        }
      }
    }
  }
}

export function ajaxPostPromise (url ,payload) {
  return new Promise((resolve, reject) =>{
    ajaxPost(url , payload, resolve, reject)
  })
}
export function ajaxGet (url, successCb, errorCb) {
  const cookies = BrowserUtils.parseCookie(document.cookie);
  let ignoreCsrfToken = false
  if (url.startsWith('http') || url.startsWith('https')) {
    if (new URL(url).origin !== location.origin) {
      ignoreCsrfToken = true
    }
  }

  if (window.fetch) {
    const headers = {
      'Content-Type': 'application/json'
    }
    if (cookies['XSRF-TOKEN'] && !ignoreCsrfToken) {
      headers['X-XSRF-TOKEN'] = cookies['XSRF-TOKEN']
    }
    window.fetch(url, {
      method: 'GET',
      headers
    }).then(function (response) {
      if (response.status === 200) {
        return response.json()
      } else {
        return response.json().then(errorCb)
      }
    }).then(function (data) {
      successCb(data)
    }).catch(function (err) {
      errorCb(err)
    })
  } else {
    const xhr = new XMLHttpRequest()
    // xhr.timeout = 30000
    xhr.open('GET', url)
    xhr.setRequestHeader('Content-Type', 'application/json')
    if (cookies['XSRF-TOKEN'] && !ignoreCsrfToken) {
      xhr.setRequestHeader('X-XSRF-TOKEN', cookies['XSRF-TOKEN'])
    }
    xhr.send()
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          successCb(JSON.parse(xhr.responseText))
        } else {
          errorCb(JSON.parse(xhr.responseText))
        }
      }
    }
  }
}
